import { Button, Col, Modal, Row } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';

export const RefreshModal = (props) => {
  const { onHide, show } = props;
  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      variant="secondary"
      show={show}
    >
      <Modal.Body>
        <Container className="mt-md-4 mb-md-4">
          <Row className="justify-content-md-center">
            <Col md="auto">
              <h4>New version of application is available!</h4>
            </Col>
          </Row>
          <Row className="justify-content-md-center">
            <Col md="auto">
              <Button variant="didxl" onClick={onHide}>
                Refresh
              </Button>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};
